import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type SearchPlacement = 'search_box' | 'view_more';

export type SearchTargetProperties = {
  destination_path?: string;
  placement: SearchPlacement;
  search_term: string;
};

type EventData = {
  destinationPath?: string;
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  placement: SearchPlacement;
  searchTerm: string;
};

class SearchInteractionEvent extends InteractionEvent<
  EventData,
  SearchTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'search';
  }

  protected get keepalive(): boolean {
    return true;
  }

  protected getTargetProperties(): SearchTargetProperties {
    return {
      destination_path: this.destinationPath(),
      placement: this.data.placement,
      search_term: this.data.searchTerm
    };
  }

  private destinationPath(): string | undefined {
    if (!this.data.destinationPath) return undefined;

    const url = new URL(
      this.data.destinationPath,
      'https://placeholder.invalid'
    );

    return `${url.pathname}${url.search}`;
  }
}

export default SearchInteractionEvent;
